const React = require('react');

// @vendors
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
// @components
const CreditWarranties = require('components/contactCenter/creditWarranties/creditWarranties');

class CreditInvestmentWarrantiesView extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { match: { params: { creditId } }, immInvestmentCredits } = this.props;
        const immCredit = immInvestmentCredits.getIn(['byId', creditId]);
        return (
            <CreditWarranties immCredit={immCredit}
                {...this.props}
            />
        );
    }
}

CreditInvestmentWarrantiesView.propTypes = {
    match: PropTypes.object.isRequired,
    immInvestmentCredits: PropTypes.object.isRequired
};

module.exports.constructor = CreditInvestmentWarrantiesView;
module.exports.CreditInvestmentWarrantiesView = connect(
    state => ({
        immInvestmentCredits: state.creditsInvestment
    })
)(CreditInvestmentWarrantiesView);
